module.exports = __webpack_public_path__ + "img/completion10.5a84edca.svg";